import { Globe } from 'lucide-react';
import { useCurrency } from '@/contexts/CurrencyContext';

const CurrencySelector = () => {
  const { currency, currencyOptions, changeCurrency, loading } = useCurrency();

  if (loading) {
    return (
      <div className="flex items-center gap-2 text-slate-400">
        <Globe className="h-4 w-4 animate-pulse" />
        <span className="text-sm">...</span>
      </div>
    );
  }

  return (
    <div className="relative">
      <div className="flex items-center gap-1">
        <Globe className="h-4 w-4 text-slate-500" />
        <select
          value={currency}
          onChange={(e) => changeCurrency(e.target.value)}
          className="appearance-none bg-transparent text-sm font-medium text-slate-700 cursor-pointer focus:outline-none pr-6 py-1"
          data-testid="currency-selector"
        >
          {currencyOptions.map((option) => (
            <option key={option.code} value={option.code}>
              {option.code} ({option.symbol})
            </option>
          ))}
        </select>
        <svg 
          className="h-4 w-4 text-slate-400 -ml-5 pointer-events-none" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </div>
  );
};

export default CurrencySelector;
